import { useContext, useMemo, useState } from "react";
import { BuiltInStyleMods, BuiltInStyles } from "src/managers/LinkToMapStyle";
import { changeMapStyle, MapitStateContext } from "src/states/MapitState";
import { ColorBoxEditableV2 } from "./ComponentUtils";
import { ApplicationStateContext } from "src/states/ApplicationState";
import { Localization } from "@viamap/viamap2-common";
import { MIBIcon } from "src/componentsUtils/MIBIcon";



export function MapStyleSwitch() {
   const { state: mapitState } = useContext(MapitStateContext);
   const [isNormal, setNormal] = useState(true)
   const [settingsOpen, setSettingsOpen] = useState(false)

   function handleOnClick() {
      mapitState.map.switchMapStyle(isNormal ? "NewsecV3" : "MapitV3");
      setNormal(!isNormal)
      return
   }

   return (
      <>
         {
            settingsOpen ?
               <StyleMenu />
               : <></>
         }
         <QuickStyleSwitch active={settingsOpen} onClick={handleOnClick} onSettings={() => setSettingsOpen((e) => !e)} isBlank={mapitState.mapInfo.mapStyle.name == "Blank"} />
      </>
   )
}

export function QuickStyleSwitch(props: { active?: boolean, onClick?: (e: "normal" | "orto" | "blank") => void, onSettings: () => void, isBlank?: boolean }) {
   const { state: mapitState, dispatch: mapitStateDispatch } = useContext(MapitStateContext);


   function isSelected(mod: BuiltInStyleMods) {
      let mods = mapitState.mapInfo.mapStyle.mods ?? []
      return mods.includes(mod)
   }



   if (props.isBlank) {
      return (
         <div className={"QuickOrthoStyle isBlank"}>
            <div className={"toogleSettings " + (props.active ? "active" : "")} onClick={props.onSettings} ><MIBIcon icon="Settings" /></div>
            <div onClick={() => { mapitStateDispatch(changeMapStyle({ name: mapitState.mapInfo.mapStyle.defaultStyle.name, style: mapitState.mapInfo.mapStyle.defaultStyle.style, mods: [] }, true)) }}>
               <img onMouseDown={(e) => e.preventDefault?.()} onTouchStart={(e) => e.preventDefault?.()} src={new URL("/QuickOrtoFoto/kort.png", import.meta.url).href} />
            </div>
            <div onClick={() => { mapitStateDispatch(changeMapStyle({ name: mapitState.mapInfo.mapStyle.defaultStyle.name, style: mapitState.mapInfo.mapStyle.defaultStyle.style, mods: ["Ortophoto"] }, true)) }}>
               <img onMouseDown={(e) => e.preventDefault?.()} onTouchStart={(e) => e.preventDefault?.()} src={new URL("/QuickOrtoFoto/ortofoto.png", import.meta.url).href} />
            </div>
         </div>
      )

   }

   return (
      <div className={"QuickOrthoStyle"}>
         <div className={"toogleSettings " + (props.active ? "active" : "")} onClick={props.onSettings} ><MIBIcon icon="Settings" /></div>
         <div onClick={() => { mapitStateDispatch(changeMapStyle({ name: mapitState.mapInfo.mapStyle.defaultStyle.name, style: mapitState.mapInfo.mapStyle.defaultStyle.style, mods: isSelected("Ortophoto") ? [] : ["Ortophoto"] }, true)) }}>
            <img onMouseDown={(e) => e.preventDefault?.()} onTouchStart={(e) => e.preventDefault?.()} src={new URL("/QuickOrtoFoto/kort.png", import.meta.url).href} />
            <img onMouseDown={(e) => e.preventDefault?.()} onTouchStart={(e) => e.preventDefault?.()} style={{ opacity: !(isSelected("Ortophoto")) ? 1 : 0 }} src={new URL("/QuickOrtoFoto/ortofoto.png", import.meta.url).href} />
         </div>
         <div onClick={() => { mapitStateDispatch(changeMapStyle({ style: `background-${mapitState.mapInfo.mapStyle.defaultBackgroundColor}`, name: "Blank", backgroundColor: mapitState.mapInfo.mapStyle.defaultBackgroundColor }, true)) }} className="blank" style={{ backgroundColor: mapitState.mapInfo.mapStyle.defaultBackgroundColor ?? "white" }}>
         </div>
      </div>
   )
}

export function StyleMenu() {
   const { state: mapitState, dispatch: mapitStateDispatch } = useContext(MapitStateContext);
   const { hasAccessToFeature } = useContext(ApplicationStateContext)
   let selected = mapitState.mapInfo.mapStyle.name;


   // Styles is in usestate to allow adding new styles from file drop
   const [styles, setStyles] = useState<{ name: string, style: any, colors: string[], access?: string }[]>([
      { name: "Americana", access: "mapStyle_Americana", style: "Americana", colors: ["hsl(136, 41%, 89%)", "hsl(250, 41%, 95%)", "hsl(136, 41%, 89%)", "hsl(30, 44%, 96%)", "hsl(250, 41%, 79%)", "hsl(250, 41%, 79%)"] },
      { name: "Bright", access: "mapStyle_Bright", style: "Bright", colors: ["#fff", "hsla(0, 60%, 87%, 0.23)", "hsla(49, 100%, 88%, 0.34)", "#e0e4dd", "#fde", "#f0e8f8", "hsla(30, 19%, 90%, 0.4)", "#6a4", "#d8e8c8", "#d8e8c8", "#a0c8f0", "hsl(210, 67%, 85%)", "hsl(210, 67%, 85%)", "#fff", "rgba(245, 238, 188, 1)", "#f2eae2", "rgba(255, 255, 255, 1)", "#f8f4f0", "hsla(0, 0%, 89%, 0.56)"] },
      { name: "DarkMatter", access: "mapStyle_DarkMatter", style: "DarkMatter", colors: ["#3e3e43", "#373737", "#000"] },
      { name: "Outdoors", access: "mapStyle_Outdoors", style: "Outdoors", colors: ["#fff", "#d8e8c8", "#e0e4dd", "hsla(30, 19%, 90%, 0.4)", "#d5e8c2", "hsla(0, 0%, 85%, 1)", "hsla(44, 70%, 87%, 1)", "#3D85C6", "#90d86c", "#d8e8c8", "#a0c8f0", "hsl(210, 60%, 80%)", "#fff", "#f2eae2", "rgba(255, 255, 255, 1)", "hsla(0, 0%, 89%, 0.56)"] },
      { name: "Positron", access: "mapStyle_Positron", style: "Positron", colors: ["rgb(230, 233, 229)", "rgb(194, 200, 202)", "hsl(0, 0%, 98%)", "hsl(0, 0%, 98%)", "rgb(234, 234, 230)", "rgb(220,224,220)", "rgb(234, 234, 229)", "rgba(255, 255, 255, 1)", "rgb(242,243,240)"] },
      { name: "Balder", access: "mapStyle_Balder", style: "Balder", colors: ["#e0dee0", "#90B385", "#90B385", "#edefed", "hsl(47, 26%, 88%)", "#f4f2f4", "#a2c49a", "#90B385", "#9FB3C9", "#DCDCDC", "#9FB3C9", "#d4d2d4", "#ffe", "#fcfcfc"] },
      { name: "Campaya", access: "mapStyle_Campaya", style: "Campaya", colors: ["#e0dee0", "#abcfa3", "#abcfa3", "#edefed", "hsl(47, 26%, 88%)", "#f4f2f4", "#a2c49a", "#abcfa3", "#b4cbe3", "#c8c9ca", "rgba(180, 203, 227, 1)", "#d4d2d4", "#ffe", "#fcfcfc"] },
      { name: "Danbolig", access: "mapStyle_Danbolig", style: "Danbolig", colors: ["hsl(47, 13%, 86%)", "#D2E4D0", "rgb(194, 218, 197)", "hsl(91, 18%, 71%)", "#D2E4D4", "#D2E4D0", "#D2E4D0", "hsl(47, 26%, 88%)", "hsl(47, 22%, 94%)", "#eae0d0", "hsl(150, 6%, 93%)", "hsl(175, 0%, 80%)", "hsl(175, 0%, 95%)", "#bfdcf1", "#bfdcf1"] },
      { name: "Kjeldskov", access: "mapStyle_Kjeldskov", style: "Kjeldskov", colors: ["#e0dee0", "#abcfa3", "#abcfa3", "#edefed", "hsl(47, 26%, 88%)", "#f4f2f4", "#a2c49a", "#abcfa3", "#b4cbe3", "#c8c9ca", "#b4cbe3", "#d4d2d4", "#ffe", "#fcfcfc"] },
      { name: "Klokantech", access: "mapStyle_Klokantech", style: "Klokantech", colors: ["hsl(47, 13%, 86%)", "hsl(82, 46%, 72%)", "hsl(82, 46%, 72%)", "hsl(205, 56%, 73%)", "hsla(49, 25.80%, 87.80%, 0.38)", "hsl(47, 22%, 94%)", "rgba(232, 214, 38, 1)", "#eae0d0", "#E1EBB0", "rgba(222, 211, 190, 1)", "hsl(47, 26%, 88%)", "hsl(47, 26%, 88%)", "rgba(255, 255, 255, 1)"] },
      { name: "Marselisborg", access: "mapStyle_Marselisborg", style: "Marselisborg", colors: ["#E6E4E0", "#B8EBAD", "#CEE5BF", "#F5F1F0", "hsl(47, 26%, 88%)", "#f4f2f4", "#a2c49a", "#D2E7BF", "#75CFF0", "#DCD9D6", "#75CFF0", "#d4d2d4", "#ffe", "#fcfcfc"] },
      { name: "GenericDefaultStyle", access: "mapStyle_GenericDefaultStyle", style: "GenericDefaultStyle", colors: ["#e0dee0", "#abcfa3", "#abcfa3", "#edefed", "hsl(47, 26%, 88%)", "#f4f2f4", "#a2c49a", "#abcfa3", "#b4cbe3", "#c8c9ca", "#b4cbe3", "#d4d2d4", "#ffe", "#fcfcfc"] },
      { name: "Avanceret", access: "", style: "ExplorerV3", colors: ["rgba(93, 133, 189, 0.15)", "#abcfa3", "#abcfa3", "#edefed", "hsl(47, 26%, 88%)", "#f4f2f4", "#a2c49a", "#abcfa3", "rgba(204, 224, 255, 1)", "rgba(224, 209, 184,0.5)", "#fcfcfc", "rgba(204, 224, 255, 1)", "rgba(204, 224, 255, 1)", "#d4d2d4", "#ffe"] },
      { name: "Klassisk", access: "", style: "MapitV3", colors: ["#e0dee0", "#abcfa3", "#abcfa3", "#edefed", "hsl(47, 26%, 88%)", "#f4f2f4", "#a2c49a", "#abcfa3", "#b4cbe3", "#c8c9ca", "#fcfcfc", "#b4cbe3", "#b4cbe3", "#d4d2d4", "#ffe"] },
      { name: "Skærmkort", access: "", style: "MitSkaermkort", colors: ["rgba(247, 217, 183, 1)", "#abcfa3", "rgba(147, 209, 160, 1)", "#edefed", "hsl(47, 26%, 88%)", "#f4f2f4", "#a2c49a", "#abcfa3", "rgba(194, 235, 255, 1)", "rgba(255, 177, 139, 1)", "#fcfcfc", "#b4cbe3", "rgba(181, 214, 255, 1)", "#d4d2d4", "#ffe"] },
      { name: "Sort/Hvidt", access: "", style: "Toner", colors: ["rgba(218, 218, 218, 0.51)", "rgba(236, 235, 235, 1)", "rgba(249, 249, 249, 1)", "rgb(242,243,240)"] }
   ])

   // mods is a list of style mods that can be applied to the mapStyle.
   const mods: { name: string, access?: string, mod: BuiltInStyleMods, icon: JSX.Element, negative?: boolean }[] = [
      { name: "Ortophoto", access: "mapStyleMod", mod: "Ortophoto", icon: <MIBIcon icon="ObliqueFoto" /> },
      // {name: "OrthophotoNoWaterMask", access: "", mod: "OrthophotoNoWaterMask", icon: <AirplaneSquare />},
      { name: "HillShadows", access: "mapStyleMod", mod: "HillShadows", icon: <MIBIcon icon="HeightMap" /> },
      { name: "No3D", mod: "No3D", access: "mapStyleMod", icon: <MIBIcon icon="3DEffect" />, negative: true },
      { name: "NoBuildings", mod: "NoBuildings", access: "mapStyleMod", icon: <MIBIcon icon="Buildings" />, negative: true },
      { name: "NoRoads", mod: "NoRoads", access: "mapStyleMod", icon: <MIBIcon icon="Roads" />, negative: true },
      { name: "NoAeroway", mod: "NoAeroways", access: "mapStyleMod", icon: <MIBIcon icon="Airports" />, negative: true },
      { name: "NoText", mod: "NoText", access: "mapStyleMod", icon: <MIBIcon icon="Text" />, negative: true },
   ]

   const accessableMods = useMemo(() => {
      return mods.filter((mod) => {
         if (mod.access) {
            return hasAccessToFeature(mod.access)
         } else {
            return true
         }
      });
   }, [mods, hasAccessToFeature])

   const accessableStyles = useMemo(() => {
      return styles.filter((style) => {
         if (style.access) {
            return hasAccessToFeature(style.access)
         } else {
            return true
         }
      });
   }, [styles, hasAccessToFeature])

   function handlefileDrop(e: React.DragEvent<HTMLDivElement>) {
      e.preventDefault();
      e.stopPropagation();
      const files = e.dataTransfer?.files;
      if (files && files.length > 0) {
         const file = files[0];
         const reader = new FileReader();
         reader.onload = () => {
            let style = (JSON.parse(reader.result as string))
            let name = style.name ?? "Unknown"
            let colors = getAllFillColors(style)
            navigator.clipboard.writeText(JSON.stringify(colors)).then(() => {
               console.log("Style copied to clipboard")
            });
            mapitStateDispatch(changeMapStyle({ name: name, style: style }, true));
            setStyles((prev) => {
               return [...prev, { name: name, style: style, colors: colors }]
            })
         };
         reader.readAsText(file);
      }
   }

   function handleChangeStyle(style: { style: BuiltInStyles, name: string, colors: string[] }) {
      if (typeof style.style === "string") {
         mapitStateDispatch(changeMapStyle({ style: style.style, name: style.name, backgroundColor: style.colors[0] ?? "white" }, true));
      } else {
         mapitStateDispatch(changeMapStyle(style, true));
      }
   }

   return (
      <div className="StyleMenu" style={{ position: "absolute" }} onDragOver={(e) => e.preventDefault()} onDrop={(e) => handlefileDrop(e)}>
         <div className="menuScroll">
            {accessableStyles.map((style, i) => {
               return (
                  <div key={i} className={"StyleMenuItem " + (selected == style.style ? "selected" : "")} onClick={() => handleChangeStyle(style)} >
                     <StylePreview colors={style.colors} />
                     <div className="StyleMenuItemText">{style.name}</div>
                  </div>
               )
            })}
         </div>
         <BlankMapStyle />
         {mapitState.mapInfo.mapStyle.name == "Blank" ?
            <></> :
            <StyleMods mods={accessableMods} />
         }
      </div>
   )
}

function StylePreview(props: { colors: string[] }) {
   let colorL = props.colors.length;
   let colorTop = colorL / 2;

   return (
      <div className="StylePreview" >
         <div className="colorCon" style={{}}>
            <div className="colorRow">
               {
                  props.colors.filter((a, i) => i < colorTop).map((color, i) => {
                     return <div key={i} className="color" style={{ backgroundColor: color }}></div>
                  })
               }
            </div>
            <div className="colorRow">
               {
                  props.colors.filter((a, i) => i >= colorTop).map((color, i) => {
                     return <div key={i} className="color" style={{ backgroundColor: color }}></div>
                  })
               }
            </div>
         </div>
      </div>
   )
}

function getAllFillColors(style: any): string[] {
   let colors: string[] = []
   for (let i = 0; i < style.layers.length; i++) {
      let layer = style.layers[i];
      if (layer.paint && layer.paint["fill-color"] && typeof layer.paint["fill-color"] === "string") {
         colors.push(layer.paint["fill-color"])
      }
   }
   return colors
}

function BlankMapStyle() {
   const { state: mapitState, dispatch: mapitStateDispatch } = useContext(MapitStateContext);
   let selected = mapitState.mapInfo.mapStyle;

   function handleStyle(color: string) {
      mapitStateDispatch(changeMapStyle({ style: `background-${color}`, name: "Blank", backgroundColor: color }));
   }

   return (
      <div className={"StyleMenuItem " + (selected.name == "Blank" ? "selected" : "")} onClick={() => handleStyle(selected.backgroundColor ?? "white")} >
         <div className="StylePreview" onClick={((e) => e.stopPropagation())} >
            <ColorBoxEditableV2 color={mapitState.mapInfo.mapStyle.backgroundColor ?? "white"} onCommit={(color) => handleStyle(color)} />
         </div>
         <div className="StyleMenuItemText">Blank</div>
      </div>
   )
}

function StyleMods(props: { mods: { name: string, access?: string, mod: BuiltInStyleMods, icon: JSX.Element, negative?: boolean }[] }) {
   const { state: mapitState, dispatch: mapitStateDispatch } = useContext(MapitStateContext);

   function toogleMod(mod: BuiltInStyleMods) {
      let mods = mapitState.mapInfo.mapStyle.mods ?? []
      if (mods.includes(mod)) {
         mods = mods.filter((m) => m != mod)
      } else {
         mods.push(mod)
      }
      mapitStateDispatch(changeMapStyle({ mods: mods }, true))
   }

   function isSelected(mod: BuiltInStyleMods) {
      let mods = mapitState.mapInfo.mapStyle.mods ?? []
      return mods.includes(mod)
   }



   return (
      <div className="StyleModsCon">
         {props.mods.map((mod, i) => {
            return (
               <div title={Localization.getFormattedText("Turn {mod} on/off", { mod: Localization.getText("mod:" + mod.name) })} key={i} className={"StyleMenuItem " + (mod.negative ? "negative " : "") + (isSelected(mod.mod) ? "selected" : "")} onClick={() => { toogleMod(mod.mod) }}>
                  {mod.icon}
               </div>
            )
         })}
      </div>
   )
}